import { BlockType } from '@reliance/types/models/Block';

export function formatBlockType(blockOrTreatment: number|BlockType) {
  let blockTypeTreatment;
  if (typeof blockOrTreatment !== 'number') {
    blockTypeTreatment = blockOrTreatment.treatment;
  } else {
    blockTypeTreatment = blockOrTreatment;
  }

  switch (blockTypeTreatment) {
    case 1: return 'Collect Block';
    case 2: return 'Recording Block';
    case 3: return 'County Block';
    case 4: return 'Range Block';
    case 5: return 'Override';
    case 9: return 'Facility Block';
    default: return 'Unknown';
  }
}